export const findChildren = (parent, name, recursive) => {
    if (!parent) return null;

    const { children } = parent;
    const { length } = children;
    let i;
    let ch;
    let result = null;

    for (i = 0; i < length; i += 1) {
        ch = children[i];

        if (ch.name === name) result = ch;
        else if (recursive) result = findChildren(ch, name, recursive);

        if (result) break;
    }

    return result;
};
